import { TrendingEnumSeriesData } from '@store';

export function getSeriesInXRangeDataFormat(
  data: TrendingEnumSeriesData,
  pointEnd: number
): { x: number; x2: number; y: number }[] {
  const xRangeData: { x: number; x2: number; y: number }[] = [];

  const valueStart = data.start;
  data.value.forEach((value, index) => {
    const isFirstElement = index === 0;
    const isLastElement = index === data.value.length - 1;

    if (isFirstElement) {
      xRangeData.push({
        x: valueStart[index],
        x2: valueStart[1] ?? pointEnd,
        y: value,
      });
    } else if (!isLastElement) {
      xRangeData.push({
        x: valueStart[index],
        x2: valueStart[index + 1],
        y: value,
      });
    } else {
      xRangeData.push({
        x: valueStart[index],
        x2: pointEnd,
        y: value,
      });
    }
  });

  return xRangeData;
}
